<template>
  <div class="dh-node">
    <div
      class="dh-row"
      :class="{ 'dh-selectable': isObject, 'dh-selected': isSelected }"
      :style="{ 'padding-left': (level * 16 + 4) + 'px' }"
      @click="onRowClick"
    >
      <span class="dh-caret" @click.stop="toggle">
        <fa v-if="hasChildren" :icon="expanded ? 'minus' : 'plus'" />
      </span>

      <span class="dh-label" :class="{ 'dh-deleted': node.deleted }">
        {{ node.label }}
        <span v-if="node.kind === 'group'" class="text-muted">({{ groupCount }})</span>
        <span v-if="node.deleted" class="badge badge-secondary dh-deleted-badge">{{ $t('core.deleted') }}</span>
      </span>

      <span class="dh-meta">
        <span v-if="node.change_count > 0" class="badge dh-count" :class="isObject ? 'badge-primary' : 'badge-light'">
          {{ node.change_count }}
        </span>
        <span v-if="node.last_changed_at" class="dh-date text-muted">{{ node.last_changed_at | formatDatetime }}</span>
      </span>
    </div>

    <template v-if="expanded">
      <o-data-history-tree-node
        v-for="(child, index) in visibleChildren"
        :key="index"
        :node="child"
        :level="level + 1"
        :selected-key="selectedKey"
        :hide-unchanged="hideUnchanged"
        @select="$emit('select', $event)"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'o-data-history-tree-node',

  props: {
    node: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    selectedKey: {
      type: String,
      default: null
    },
    hideUnchanged: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      // Expand the root and its immediate groups by default; collapse deeper.
      expanded: this.level < 2
    }
  },

  computed: {
    isObject () {
      return this.node.kind === 'object'
    },
    visibleChildren () {
      const children = Array.isArray(this.node.children) ? this.node.children : []
      if (!this.hideUnchanged) {
        return children
      }
      return children.filter(child => (child.subtree_change_count || 0) > 0)
    },
    hasChildren () {
      return this.visibleChildren.length > 0
    },
    groupCount () {
      return this.hideUnchanged ? this.visibleChildren.length : this.node.count
    },
    isSelected () {
      return this.isObject && this.selectedKey === this.node.type + '|' + this.node.id
    }
  },

  methods: {
    toggle () {
      if (this.hasChildren) {
        this.expanded = !this.expanded
      }
    },
    onRowClick () {
      if (this.isObject) {
        this.$emit('select', this.node)
      } else {
        this.toggle()
      }
    }
  }
}
</script>

<style scoped>
.dh-row {
  display: flex;
  align-items: center;
  padding: 3px 6px 3px 4px;
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
}
.dh-row:hover {
  background-color: #f1f3f5;
}
.dh-selected {
  background-color: #e7f1ff !important;
}
.dh-caret {
  display: inline-block;
  width: 16px;
  text-align: center;
  flex: 0 0 16px;
  color: #868e96;
  font-size: 0.7rem;
}
.dh-label {
  margin-left: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dh-deleted {
  text-decoration: line-through;
  color: #adb5bd;
}
.dh-deleted-badge {
  margin-left: 6px;
  vertical-align: middle;
}
.dh-meta {
  margin-left: auto;
  padding-left: 12px;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}
.dh-count {
  margin-right: 8px;
}
.dh-date {
  font-size: 0.78rem;
}
</style>
